var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_2159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8332H10.8333V14.9998C10.8333 15.4582 10.4583 15.8332 9.99996 15.8332C9.54163 15.8332 9.16663 15.4582 9.16663 14.9998V10.8332H4.99996C4.54163 10.8332 4.16663 10.4582 4.16663 9.99984C4.16663 9.5415 4.54163 9.1665 4.99996 9.1665H9.16663V4.99984C9.16663 4.5415 9.54163 4.1665 9.99996 4.1665C10.4583 4.1665 10.8333 4.5415 10.8333 4.99984V9.1665H15C15.4583 9.1665 15.8333 9.5415 15.8333 9.99984C15.8333 10.4582 15.4583 10.8332 15 10.8332Z",
    fill: "#00A0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_2159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.d9c067a13a502afa12b96b4ab056873c.svg";
export { ForwardRef as ReactComponent };